<template>
  <div class="promo-card story">
    <div class="promo-card__card bg-white">
      <div class="promo-card__actions">
        <div>
          <a-select :value="selectedLanguage" size="small" @change="handleLangChange" class="lang-select">
            <a-select-option v-for="lang in langOptions" :key="lang.value">
              {{ lang.name }}
            </a-select-option>
          </a-select>
        </div>
        <div>
          <a-button v-if="!isViewscreen" type="link" :disabled="!editPermission" @click="openEditPage"
            class="mr-3"><a-icon type="edit" class="text-primary font-size-16" />Edit</a-button>
          <a-checkbox v-if="isViewscreen" :checked="addToViewscreen" @change="handleViewscreenChange" />
        </div>
      </div>
      <div class="promo-card__content" style="padding-bottom: 8px;" @click="openFullInfoModal">
        <div class="promo-card__main">
          <div class="">
            <img class="promo-card__image" :src="selectedPreview" alt="Story preview" />
          </div>
          <div class="promo-card__left" style="position: relative; top: -14px;">
            <div class="mb-2">
              <div class="promo-card--title">Tech name</div>
              <span class="promo-card-title promo-card--text">{{ storyContext.name }}</span>
            </div>
            <div class="mb-2">
              <div class="promo-card--title">Section</div>
              <div v-if="Array.isArray(storyContext.displays) && storyContext.displays.length"
                style="line-height: 1.8rem">
                <a-tag class="info-modal--tag" v-for="display in storyContext.displays" :key="display.id">
                  {{ displays[display.id] }}
                </a-tag>
              </div>
              <div v-else>-</div>
            </div>
            <div>
              <div class="promo-card--title">Apps</div>
              <div style="line-height: 2.1rem">
                <a-tag style="margin-right: 15px; padding: 1px 8px; border-radius: 2px"
                  v-for="app in storyContext.applications.slice(0, 2)" :key="app.id">
                  {{ app.name }}
                  <a-icon v-if="app.platform.toLowerCase() === 'android'" type="android" class="ml-1 text-success" />
                  <a-icon v-if="app.platform.toLowerCase() === 'ios'" type="apple" class="ml-1 text-primary" />
                  <a-icon v-if="app.platform.toLowerCase() === 'web'" type="global" class="ml-1 text-default" />
                </a-tag>
                <a-tag v-if="storyContext.applications.length > 2">
                  ...
                </a-tag>
              </div>
            </div>
          </div>
        </div>
        <div v-if="storyContext.periods">
          <div class="promo-card--title">Show Period</div>
          <div style="line-height: 2.1rem">
            <a-tag style="padding: 1px 8px; border-radius: 2px"
              v-for="period in storyContext.periods.slice(0, 1)" :key="period.starts_at">
              {{ `${formatDate(period.starts_at)} - ${formatDate(period.ends_at)} ${formatTimezone(period.time_mode)}` }}
            </a-tag>
            <a-tag v-if="storyContext.periods.length > 1" style="padding: 1px 8px; border-radius: 2px">
              {{ `+${storyContext.periods.length - 1}` }}
            </a-tag>
          </div>
        </div>
      </div>
      <div class="promo-card__footer">
        <div class="d-flex align-items-center" :class="{ 'promo-card__footer--inf': !firstPeriodStart }">
          <div class="text-uppercase mr-auto">
            <span v-if="firstPeriodStart">
              {{ formatDate(firstPeriodStart) }} -
            </span>
            <span v-if="lastPeriodEnd">
              {{ formatDate(lastPeriodEnd) }}
            </span>
            <span v-else style="font-size: 20px;">&infin;</span>
          </div>
          <div class="d-flex">
            <a-switch :default-checked="storyContext.is_active" @change="storyActiveSwitch"
              :disabled="!editPermission" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import apiClient from '@/services/axios'
import MediaService from '@/services/api/apiMediaService'

import { formatTimezone } from '@/services/utils/media'

export default {
  name: 'Story-card',
  props: {
    storyInfo: {
      type: Object,
    },
    editPermission: {
      type: Boolean,
    },
    languages: {
      type: Array,
    },
    isViewscreen: {
      type: Boolean,
      default: false,
    },
    isMediaChecked: {
      type: Boolean,
      default: false,
    },
    displays: {
      type: Object,
    },
  },
  data: () => ({
    selectedLanguage: 'ru',
    addToViewscreen: false,
  }),
  computed: {
    storyContext() {
      return this.storyInfo.context.context
    },
    langOptions() {
      const langKeys = Object.keys(this.storyContext.previews)
      return this.languages.filter(language => langKeys.includes(language.name)).map(language => ({
        name: language.desc,
        value: language.name,
      }))
    },
    selectedPreview() {
      return this.storyContext.previews?.[this.selectedLanguage]?.[0]?.path || ''
    },
    firstPeriodStart() {
      if (!this.storyContext?.periods?.length) {
        return null
      }

      return this.storyContext.periods[0].starts_at
    },
    lastPeriodEnd() {
      if (!this.storyContext?.periods?.length) {
        return null
      }

      const lastIndex = this.storyContext.periods?.length - 1

      return this.storyContext.periods[lastIndex].ends_at
    },
  },
  watch: {
    isMediaChecked(value) {
      this.addToViewscreen = value
    },
  },
  created() {
    if (this.isMediaChecked) {
      this.addToViewscreen = true
    }
    if (this.langOptions.length) {
      this.selectedLanguage = this.langOptions[0].value
    }
  },
  methods: {
    formatTimezone,
    openFullInfoModal() {
      this.$emit('openFullInfo')
    },
    openEditPage() {
      this.$emit('openEdit')
    },
    formatDate: function (date) {
      return this.$moment(date).format('DD.MM.YY HH:mm')
    },
    handleLangChange(selectedLangKey) {
      this.selectedLanguage = selectedLangKey
    },
    handleViewscreenChange(event) {
      this.addToViewscreen = event.target.checked
      const action = event.target.checked ? 'addToMediaArray' : 'deleteFromMediaArray'
      this.$emit(action, this.storyInfo.id)
    },
    async storyActiveSwitch(checked) {
      try {
        const storyPayload = {
          is_active: checked,
        }
        const storyResponse = await MediaService.updateStory(this.storyContext.id, storyPayload)
        this.$notification.success({
          message: 'Active status changed',
          description: `${this.storyContext.name} status have been changed`,
        })
        if (storyResponse?.data?.error || storyResponse.data.success === false || storyResponse.data.error) {
          const errorMessage =
          storyResponse.data.error?.message ||
            'Something went wrong while updating story activity'
          this.$notification.error({
            message: errorMessage,
          })
          this.loading = false
          return
        }
      } catch (e) {
        const errorMessage =
          e.response.data?.error?.message ||
          'Something went wrong while updating story activity'
        this.$notification.error({
          message: errorMessage,
        })
      }
    },
  },
}
</script>

<style lang="scss" src="../style.module.scss" />
